<portal-page-heading>
  {{ 'productOptions.title' | translate }}

  <ng-container actions>
    <!-- Refresh -->
    <portal-icon-button
      [loading]="loading$ | async"
      [portalTippy]="'generic.reload' | translate"
      (onClick)="refresh()"
      iconClass="far fa-sync"
    ></portal-icon-button>
  </ng-container>
</portal-page-heading>

<portal-loading-indicator-container [loading]="loading$ | async">
  <portal-errors [errors]="error$ | async"></portal-errors>

  <div class="row">
    @for (entry of viewModel$ | async; track entry) {
      <portal-card class="col-12 col-sm-6 col-md-4">
        <div class="overflow-hidden" header>
          <h2>{{ entry.name }}</h2>
          @if (entry.description != null) {
            <div class="text-truncate">{{ entry.description }}</div>
          }
        </div>
        <!-- Subrole -->
        @if (entry.subrole != null) {
          <dl>
            <!-- Name and description -->
            <dt>{{ 'productOptions.subrole' | translate }}</dt>
            <dd>
              <div>
                <div>{{ entry.subrole.name }}</div>
                @if (entry.subrole.description | notBlank) {
                  <span class="text-muted">
                    {{ entry.subrole.description }}
                  </span>
                }
              </div>
            </dd>
            <!-- Additional permissions -->
            <dt>{{ 'productOptions.subrole.additionalPermissions' | translate }}</dt>
            <dd>
              @if (entry.subrole.additionalPermissions.length === 0) {
                <div>
                  {{ 'productOptions.subrole.noAdditionalPermissions' | translate }}
                </div>
              }
              <ul class="list-comma">
                @for (permission of entry.subrole.additionalPermissions; track permission) {
                  <li>
                    <code>{{ permission.name }}</code>
                  </li>
                }
              </ul>
            </dd>
            <!-- Restrictive permissions -->
            <dt>{{ 'productOptions.subrole.restrictivePermissions' | translate }}</dt>
            <dd>
              @if (entry.subrole.restrictivePermissions.length === 0) {
                <div>
                  {{ 'productOptions.subrole.noRestrictivePermissions' | translate }}
                </div>
              }
              <ul class="list-comma">
                @for (permission of entry.subrole.restrictivePermissions; track permission) {
                  <li>
                    <code>{{ permission.name }}</code>
                  </li>
                }
              </ul>
            </dd>
          </dl>
        } @else {
          <div>{{ 'productOptions.noSubrole' | translate }}</div>
        }
      </portal-card>
    }
  </div>
</portal-loading-indicator-container>
